<script>
	import { onDestroy } from "svelte";

	//Store
	import { BankStore } from "../store";

	let bankData;

	//Stores
	const unsubBankStore = BankStore.subscribe((data) => {
		bankData = data;
	});

	onDestroy(() => {
		unsubBankStore();
	});
</script>

<div class="row">
	<div
		class="col my-4 d-flex flex-wrap justify-content-between align-items-start">
		{#if true}
			<!-- Domestic Monthly Bank Counter -->
			<h5 class="mb-0 d-flex align-items-center cursor-default mr-3 mb-3">
				Monthly Bank
				<span class="badge badge-light ml-2">
					{#if bankData && bankData.monthlyBank}
						{bankData.monthlyBank.totalAmount
							.toString()
							.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}/-
					{:else}0/-{/if}
				</span>
			</h5>

			<!-- Domestic Reserve Bank Counter -->
			<h5 class="mb-0 d-flex align-items-center cursor-default">
				Reserve Bank
				<span class="badge badge-light ml-2">
					{#if bankData && bankData.reserveBank}
						{bankData.reserveBank.totalAmount
							.toString()
							.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}/-
					{:else}0/-{/if}
				</span>
			</h5>
		{/if}
	</div>
</div>
